export function cashGrantLevelText(locale) {
    return locale === 'az' ? 'İcazə səviyyəsi' : locale === 'ru' ? 'Уровень прав' : 'Permission level';
}
export function cashStandardSourceText(locale) {
    return locale === 'az' ? 'Standart mədaxil mənbəyi' : locale === 'ru' ? 'Стандартный источник прихода' : 'Standard income source';
}
export function cashRoleText(locale, role) {
    if (!role)
        return locale === 'az' ? 'Giriş yoxlanılır…' : locale === 'ru' ? 'Доступ проверяется…' : 'Checking access…';
    const labels = {
        ADMIN: ['Администратор кассы', 'Kassa administratoru', 'Cash administrator'],
        MANAGER: ['Менеджер кассы', 'Kassa rəhbəri', 'Cash manager'],
        CASHIER: ['Кассир', 'Kassir', 'Cashier'],
        VIEWER: ['Просмотр кассы', 'Kassaya baxış', 'Cash viewer'],
        NONE: ['Доступ к кассе не назначен', 'Kassaya giriş təyin edilməyib', 'No Cash access assigned'],
    };
    return labels[role][locale === 'az' ? 1 : locale === 'en' ? 2 : 0];
}
export function cashAdminOutcome(locale, userName, revoked) {
    return locale === 'az' ? `${userName}: Kassa administratoru profili ${revoked ? 'ləğv edildi' : 'təyin edildi'}.` :
        locale === 'ru' ? `${userName}: профиль администратора Кассы ${revoked ? 'отозван' : 'назначен'}.` :
            `${userName}: Cash administrator profile ${revoked ? 'revoked' : 'assigned'}.`;
}
